/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Status change details including new status and reason
 * @export
 * @interface StatusChangeRequest
 */
export interface StatusChangeRequest {
    /**
     * New status for the case
     * @type {string}
     * @memberof StatusChangeRequest
     */
    status: StatusChangeRequestStatusEnum;
    /**
     * Reason for the status change
     * @type {string}
     * @memberof StatusChangeRequest
     */
    reason?: string;
    /**
     * Additional notes about the status change
     * @type {string}
     * @memberof StatusChangeRequest
     */
    notes?: string;
    /**
     * Whether to create a timeline event for this status change
     * @type {boolean}
     * @memberof StatusChangeRequest
     */
    createTimelineEvent?: boolean;
    /**
     * Optional timestamp for when case was closed (for RESOLVED status)
     * @type {Date}
     * @memberof StatusChangeRequest
     */
    closedTime?: Date;
    /**
     * Optional timestamp for when case was escalated (for ESCALATED status)
     * @type {Date}
     * @memberof StatusChangeRequest
     */
    escalatedTime?: Date;
    /**
     * Optional timestamp for when case was assigned (for IN_PROGRESS status)
     * @type {Date}
     * @memberof StatusChangeRequest
     */
    assignedTime?: Date;
}


/**
 * @export
 */
export const StatusChangeRequestStatusEnum = {
    Open: 'OPEN',
    InProgress: 'IN_PROGRESS',
    Escalated: 'ESCALATED',
    Resolved: 'RESOLVED'
} as const;
export type StatusChangeRequestStatusEnum = typeof StatusChangeRequestStatusEnum[keyof typeof StatusChangeRequestStatusEnum];


/**
 * Check if a given object implements the StatusChangeRequest interface.
 */
export function instanceOfStatusChangeRequest(value: object): value is StatusChangeRequest {
    if (!('status' in value) || value['status'] === undefined) return false;
    return true;
}

export function StatusChangeRequestFromJSON(json: any): StatusChangeRequest {
    return StatusChangeRequestFromJSONTyped(json, false);
}

export function StatusChangeRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): StatusChangeRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'status': json['status'],
        'reason': json['reason'] == null ? undefined : json['reason'],
        'notes': json['notes'] == null ? undefined : json['notes'],
        'createTimelineEvent': json['createTimelineEvent'] == null ? undefined : json['createTimelineEvent'],
        'closedTime': json['closedTime'] == null ? undefined : (new Date(json['closedTime'])),
        'escalatedTime': json['escalatedTime'] == null ? undefined : (new Date(json['escalatedTime'])),
        'assignedTime': json['assignedTime'] == null ? undefined : (new Date(json['assignedTime'])),
    };
}

export function StatusChangeRequestToJSON(json: any): StatusChangeRequest {
    return StatusChangeRequestToJSONTyped(json, false);
}

export function StatusChangeRequestToJSONTyped(value?: StatusChangeRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'status': value['status'],
        'reason': value['reason'],
        'notes': value['notes'],
        'createTimelineEvent': value['createTimelineEvent'],
        'closedTime': value['closedTime'] == null ? undefined : ((value['closedTime']).toISOString()),
        'escalatedTime': value['escalatedTime'] == null ? undefined : ((value['escalatedTime']).toISOString()),
        'assignedTime': value['assignedTime'] == null ? undefined : ((value['assignedTime']).toISOString()),
    };
}

